import ThingIcon from '@mui/icons-material/Help';

export default ThingIcon;
